// extracted by mini-css-extract-plugin
export default {"Loading":"bcu_a bic_a bic_w bic_j bic_ul bic_um bic_fm"};